export const module = {
  info: {
    name: 'voip-mrt-enterprise-vendor',
    caption: 'voip-mrt-enterprise-vendor',
    viewGroup: 'mrt-modules'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'Setting',
    icon: 'el-icon-folder',
    routeName: 'module->voip-mrt-enterprise-vendor->create',
    children: [
      {
        caption: 'Create Vendors',
        icon: 'el-icon-plus',
        routeName: 'module->voip-mrt-enterprise-vendor->create'
      },
      {
        caption: 'List Vendors',
        icon: 'el-icon-more-outline',
        routeName: 'module->voip-mrt-enterprise-vendor->list->page',
        routeParams: { listPage: 1}
      },
      {
        caption: 'Rates Panel',
        icon: 'el-icon-more-outline',
        routeName: 'module->voip-mrt-enterprise-vendor->rates-panel->tab',
        routeParams: { tabName: 'uploadDocument'}
      }
    ]
  }
}

export default module
